<template>
  <b-container fluid class="search_box_modal">
    <b-row style="height:90px;margin-top:-20px;" class="search_header"
           :style="{backgroundColor: getCssColor('primary_bt')}">
      <b-col style="margin-top:40px;padding:0px;padding-left:16px;">
        <input @focus="resizeScrollable()" @keydown="resizeScrollable()" @blur="resetScrollable()"
               placeholder="digite o nome do produto" ref="searchBoxDom" class="search_box_input" type="search"
               v-model="searchTerm"/>
      </b-col>
      <b-col cols="3" style="margin-top:40px;text-align:center;padding:0px;padding-right:16px;">
        <button @click="closeSearch()" class="bt_cancel_search">cancelar</button>
      </b-col>
    </b-row>
    <InnerLoading v-show="loading"/>
    <b-row ref="rowBox" style="height:calc(100vh - 73px);overflow-x:hidden;overflow-y:auto;">
      <b-col>
        <b-row v-for="(product, idxp) in $store.state.searchedProducts" v-bind:key="idxp"
               @click="openProduct(product)"
               style="min-height:60px;font-size:14px;border-bottom:1px solid rgb(221, 221, 221);background-color:#ffffff;">
          <b-col cols="3" style="cursor:pointer;padding-left:0px;text-align:center;">
            <img v-if="product.photos.length" @error="imgUrlAlt" :alt="product.name" class="foto_search_box"
                 :src="productImageURI + '/' + product.photos[0].id"/>
            <img v-else :alt="product.name" class="foto_search_box"
                 src="https://cdnimages.opa4.store/img/fixedimg/no-picture.png"/>
            <AtacarejoSticker style="right:0px;bottom:0px;text-align:center;" :productView='product.product_views[0]'/>
            <PromoSticker style="position:absolute;left:0px;top:-5px;" v-if="product.product_views[0].promotional_price"
                          :discount="Math.round(100 - ((product.product_views[0].promotional_price / product.product_views[0].price) * 100))"/>
          </b-col>
          <b-col>
            <b-row>
              <b-col class="search_box_product_name">{{product.name.toLowerCase()}}</b-col>
            </b-row>
            <b-row>
              <b-col class="search_box_product_name" style="padding-top:0px;">
                <template v-if="!product.product_views[0].promotional_price"><span class="search_price_to"
                                                                                   :style="{color:getCssColor('primary_bt')}">R$ {{formatPrice(product.product_views[0].price)}}</span>
                </template>
                <template v-else><span
                  class="search_price_from">De: R${{formatPrice(product.product_views[0].price)}}</span> <span
                  class="search_price_to" style="margin-left:10px;" :style="{color:getCssColor('primary_bt')}"> Por: R${{formatPrice(product.product_views[0].promotional_price)}}</span>
                </template>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import navigation from '@/mixins/navigation'
  import InnerLoading from '@/components/InnerLoading'
  import colors from '@/mixins/colors'
  import ProductsConn from '@/connection/productsv2'
  import AtacarejoSticker from '@/components/AtacarejoSticker'
  import PromoSticker from '@/components/PromoSticker'
  import formaters from '@/mixins/formaters.js'
  import _ from 'lodash'

  export default {

    data() {
      return {
        loading: false,
        searchTerm: ''
      }
    },

    components: {InnerLoading, AtacarejoSticker, PromoSticker},

    mixins: [colors, navigation, formaters],

    watch: {
      searchTerm: function (val) {
        if (val) {
          this.$store.state.searchTerm = val.trim()
          this.doSearch()
        }
      }
    },

    computed: {

      productImageURI() {
        return this.$store.getters.getProductImageURI
      }
    },

    async created() {

      await ProductsConn.getProductsIndex()

      this.searchTerm = this.$store.state.searchTerm
      this.doSearch = _.debounce(function () {
        this.remoteSearch()
      }, 400)
      // this.doSearch()
    },

    mounted() {
      this.$refs.searchBoxDom.focus()
      window.scrollTo(0, 0)
      if (this.IOS) {
        this.$refs.rowBox.style.height = "calc(100vh - 73px)"
      }
    },


    methods: {

      openProduct (product) {
        if (this.$store.state.company.company_type && this.$store.state.company.company_type === 'RESTAURANT'){
          this.gotToPath('/productfood/'+product.id)
        } else {
          this.gotToPath('/product/'+product.id)
        }
      },

      resizeScrollable() {
        if (this.IOS) {
          window.scrollTo(0, 0)
          this.$refs.rowBox.style.height = "calc(363px - 73px)"
        }
      },

      resetScrollable() {
        if (this.IOS) {
          window.scrollTo(0, 0)
          this.$refs.rowBox.style.height = "calc(100vh - 73px)"
        }
      },

      clearSearch() {
        this.$store.state.searchTerm = null
        this.searchTerm = ''
        this.$store.state.searchedIndexes = []
        this.$store.state.lastSearchTime = 0
        this.$store.state.searchedProducts = []
        this.$store.state.searchingProducts = false
      },

      closeSearch() {
        this.clearSearch()
        this.$store.state.activeSearch = false
        //if (this.$store.state.company.company_type && this.$store.state.company.company_type === 'RESTAURANT'){
          this.$router.push({path: '/home'})
        //} else {
        //  this.$router.push({path: '/categories/0'})
        //}
      },


      async remoteSearch() {
        let vm = this
        this.loading = true
        if (this.$store.state.searchTerm && this.$store.state.searchTerm.length >= 2) {
          this.$store.state.searchedIndexes = []
          const limitListSize = 80
          let filterdProducts = this.filterIndexes(limitListSize)
          // console.log(this.$store.state.searchedIndexes)
          this.$store.state.searchingProducts = true
          if (filterdProducts && filterdProducts.length) {
            this.$store.state.searchedIndexes = filterdProducts.map((m) => m.id)
            this.$store.state.searchedProducts = []
            let indexes = _.clone(this.$store.state.searchedIndexes)
            console.log('filtered index:', indexes)
            let search = await ProductsConn.getProductsByIds(indexes)
            if (!search.error) {
              // consider ignore stock filter
              if (this.$store.getters.getChoicedCompany.stock_configuration === true) {
                this.$store.state.searchedProducts = search.filter(p => p.active === true && !p.expires_at &&  p.product_views[0].stock_quantity > 0)
              } else {
                this.$store.state.searchedProducts = search.filter(p => p.active === true && !p.expires_at)
              }
              // Aplica o score (priority) na lista de produtos preenchidas recebidas do servidor.
              for (let x = 0; x < this.$store.state.searchedProducts.length; x++) {
                filterdProducts.find((element) => {
                  let result = element.id == vm.$store.state.searchedProducts[x].id;
                  this.$store.state.searchedProducts[x].priority = element.priority
                  return result
                })
              }
              // Ordena lista de acordo com as prioridades
              this.$store.state.searchedProducts.sort((a,b) => {
                return a.priority - b.priority
              })

            } else {
              console.log('Error to fetch products')
              this.$store.state.searchedProducts = []
            }
            this.loading = false
            this.$store.state.searchingProducts = false
          } else {
            console.log('index not found')
            this.loading = false
            this.$store.state.searchedProducts = []
            this.$store.state.searchingProducts = false
          }
        } else {
          this.$store.state.searchedProducts = []
          this.loading = false
        }
      },

      /** 
       * Faz um busca para saber se o termo tem a ver com o produto.
       * @param product - Objecto produto, contendo pelo menos os atributos id e nome, caso lookEan=true precisa ter ean
       * @param searchTerms - Array de String com os termos a serem buscados.
       * @param lookEan (opcional) - Booleano para indicar se deve ser buscado o valor no atributo EAN do produto.
       * @returns Numero inteiro com o score negativo ou zero. Quando menor o score melhor e o resultado da busca.
       * score 0 representa que o termo nao tem a ver com o produto.
       */
      classificatePriorityMatch(product, searchTerms, lookEan) {
        let productName = product.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        let score = 0;
        for (let x = 0; x < searchTerms.length; x++) {
          let term = searchTerms[x]
          let indexOf = productName.indexOf(term)

          // Caso de palavras curtas (2 letras) o match tem q ser exato.
          if (term.length == 2) {
            if (indexOf !== -1) {
              if (productName.match(new RegExp( '\\b' + term + '\\b'))) {
                score -= 800
                score -= Math.abs(100 - indexOf)
              }
            }
          } if (term.length > 2) {
            // Encontrando as palavras pra dar o match
            if (indexOf !== -1) {
              if (productName.match(new RegExp( '^' + term + '\\b'))) {
                score -= 1000
              } else if (productName.match(new RegExp( '\\b' + term + '\\b'))) {
                score -= 800
              } else if (productName.match(new RegExp( '\\b' + term ))) {
                score -= 700
              } else {
                score -= 500
              }
              score -= Math.abs(100 - indexOf)

              // Faz a busca considerando o EAN do produto.
              if (lookEan) {
                let normalizedEan = product.ean.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                let eanScore = normalizedEan.indexOf(term)
                if (eanScore != -1) {
                  score -= eanScore
                }
              }
            }
          }
        }
        return score;
      },

      /**
       * @param maxListSize (opctional) - Tamanho da lista a ser retornada
       * @returns Lista de produtos filtrados, ordenados e com o atributo priority aplicado o score da busca
       */
      filterIndexes(maxListSize) {
        let searchTerm = _.clone(this.$store.state.searchTerm)
        let products = _.clone(this.$store.state.productsIndex)

        let terms = searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(' ')
        console.log("terms:", terms)
        // console.log("products:", products)
        products = products.filter((product) => {
          product.priority = this.classificatePriorityMatch(product, terms)
          return product.priority != 0
        })
        
        // Ordena e faz splice antes de enviar para o servidor
        products = products.sort((a,b) => {
          return a.priority - b.priority
        })
        if (maxListSize) {
          products = products.slice(0,maxListSize)
        }
        // console.log("filtered:", products)
        return products
      }
    }

  }
</script>

<style lang="scss">

  .search_header {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    //position:fixed;
    top: -20px !important;
    width: 100vw;
    max-width:1336px;
    z-index: 19000;
  }

  .search_box_modal {
    // display: none;
    // top:0;
    // z-index:12001;
    background-color: #FAFAFA;
    max-width:1336px;
    //height:100vh;
  }

  .search_box_input {
    -webkit-user-modify: read-write-plaintext-only;
    border: 1px solid #ffffff;
    height: 30px;
    font-size: 16px;
    border-radius: 4px;
    width: 100%;
    background-color: #ffffff;
    padding: 0 8px 0 8px;
  }

  .bt_cancel_search {
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    background-color: transparent;
    border: 0px;
  }

  .foto_search_box {
    max-width: 60px;
    max-height: 60px;
    margin: 8px;
  }

  .search_box_product_name {
    font-size: 12px;
    text-transform: capitalize;
    padding: 8px;
  }

  .search_price_to {
    font-size: 16px;
    font-weight: 500;
  }

  .search_price_from {
    font-size: 16px;
    font-weight: 500;
    color: #807C77;
    text-decoration: line-through;
  }

</style>
